import { Component, inject, OnInit } from '@angular/core'
import { SignalrService } from '../api/services/signalr.service'

@Component({
    selector: 'ppw-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    private signalrService: SignalrService = inject(SignalrService)

    ngOnInit(): void {
        this.signalrService.startConnection().then(() => {
            this.signalrService.listenToAllFeeds()
        })
    }
}
